import { connect } from 'react-redux';
import Topics from '../../components/Topics/Topics';
import { fetchCirriculum, fetchDisciplines } from '../../actions/umk';
import { getYears } from '../../actions/schedule';
import { fetchThematicPlanning, setThematicPlanningFilters } from '../../actions/thematicPlanning';

const mapStateToProps = ({ umk, schedule, thematicPlanning }) => ({
    curriculum: umk.curriculum,
    disciplines: umk.disciplines,
    schoolYears: schedule.studyYear,
    filters: thematicPlanning.filters,
    list: thematicPlanning.list,
    totalCount: thematicPlanning.count,
    isLoading: thematicPlanning.isLoading,
    hasLoaded: thematicPlanning.hasLoaded,
    loadError: thematicPlanning.loadError,
});

const mapDispatchToProps = dispatch => ({
    fetchYears: () => dispatch(getYears()),
    fetchCurriculum: (syid) => dispatch(fetchCirriculum(syid)),
    fetchDisciplines: (filters) => dispatch(fetchDisciplines(filters)),
    fetchThematicPlanning: (params) => dispatch(fetchThematicPlanning(params)),
    setFilters: (filters) => dispatch(setThematicPlanningFilters(filters)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Topics);
